(function() {
	'use strict';

	var $accordionItemHeader = $('.accordion-item__header');

	$accordionItemHeader.on('click', function() {
		var $self = $(this),
			$target = $self,
			targetOpened = !!$target.hasClass('expand');

		// Close all boxes
		$accordionItemHeader.removeClass('expand');

		// Check current box for toggle
		if (targetOpened) {
			$target.removeClass('expand');
		} else {
			$target.addClass('expand');
		}
	});
})();
